import { render } from "./IsVtaOffersSelector.vue?vue&type=template&id=e9769f6c&ts=true&lang=pug"
import script from "./IsVtaOffersSelector.vue?vue&type=script&lang=ts"
export * from "./IsVtaOffersSelector.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/gitlab-runner/builds/Ysdfp3TDT/0/z2a/z-tracker-partners/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__